import {
  hqHalfyearDraftSchema,
  hqHalfyearLoadResultSchema,
  hqHalfyearSaveResultSchema,
  type HqHalfyearDraft,
  type HqHalfyearLoadResult,
  type HqHalfyearSaveResult,
} from '@kop/contracts';

export interface HqHalfyearTransport {
  load(input: { year: number; half: 1 | 2 }): Promise<unknown>;
  execute(input: { commandId: string; expectedVersion: number; draft: HqHalfyearDraft }): Promise<unknown>;
}

export interface HqHalfyearRepository {
  load(input: { year: number; half: 1 | 2 }): Promise<HqHalfyearLoadResult>;
  save(input: { commandId: string; expectedVersion: number; draft: HqHalfyearDraft }): Promise<HqHalfyearSaveResult>;
}

/** Authentication and HQ authority belong to the injected server transport. */
export function createHqHalfyearRepository(transport: HqHalfyearTransport): HqHalfyearRepository {
  return {
    async load(input) {
      const result = hqHalfyearLoadResultSchema.parse(await transport.load(input));
      if (result.document && (result.document.draft.year !== input.year || result.document.draft.half !== input.half)) {
        throw new Error('선택한 반기의 저장본을 확인하지 못했습니다.');
      }
      return result;
    },
    async save(input) {
      const draft = hqHalfyearDraftSchema.parse(input.draft);
      const result = hqHalfyearSaveResultSchema.parse(await transport.execute({ ...input, draft }));
      if (result.receipt.commandId !== input.commandId ||
          result.receipt.version !== result.document.version ||
          result.document.version !== input.expectedVersion + 1 ||
          result.receipt.savedAt !== result.document.savedAt ||
          JSON.stringify(result.document.draft) !== JSON.stringify(draft)) {
        throw new Error('저장 결과가 일치하지 않습니다. 입력 내용을 유지했습니다.');
      }
      return result;
    },
  };
}
